import { render, staticRenderFns } from "./CreateParameter.vue?vue&type=template&id=69ddc486&"
import script from "./CreateParameter.vue?vue&type=script&lang=js&"
export * from "./CreateParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports